import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import Portal from './Portal';
import './ConfirmationModal.css';

const ConfirmationModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  confirmText = 'Confirm', 
  cancelText = 'Cancel',
  confirmButtonStyle = 'danger',
  isLoading = false
}) => {
  const { isDarkMode } = useTheme();

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget && !isLoading) {
      onClose();
    }
  };

  const confirmButtonClass = confirmButtonStyle === 'danger' 
    ? 'btn-confirm-danger' 
    : confirmButtonStyle === 'warning'
    ? 'btn-confirm-warning'
    : 'btn-confirm-primary';

  return (
    <Portal>
      <div 
        className="confirmation-modal-backdrop" 
        onClick={handleBackdropClick}
      >
        <div 
          className={`confirmation-modal ${isDarkMode ? 'dark' : 'light'}`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="confirmation-modal-header">
            <h3 className="confirmation-modal-title">{title}</h3>
          </div>
          
          <div className="confirmation-modal-body">
            <p className="confirmation-modal-message">{message}</p>
          </div>
          
          <div className="confirmation-modal-footer">
            <button
              className="btn-confirm-cancel"
              onClick={onClose}
              disabled={isLoading}
            >
              {cancelText}
            </button>
            <button
              className={confirmButtonClass}
              onClick={onConfirm}
              disabled={isLoading}
            >
              {isLoading ? 'Processing...' : confirmText}
            </button>
          </div>
        </div>
      </div>
    </Portal>
  );
};

export default ConfirmationModal;
